import { render, staticRenderFns } from "./BackupModal.vue?vue&type=template&id=3f88d1bc&"
import script from "./BackupModal.vue?vue&type=script&lang=js&"
export * from "./BackupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f88d1bc')) {
      api.createRecord('3f88d1bc', component.options)
    } else {
      api.reload('3f88d1bc', component.options)
    }
    module.hot.accept("./BackupModal.vue?vue&type=template&id=3f88d1bc&", function () {
      api.rerender('3f88d1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/BackupModal.vue"
export default component.exports